<template>
	<b-modal ref="alert-modal" title="Alert" v-model="show">

		<div v-for="event in alert" v-bind:key="event.id" class="alert alert-danger">
			Asset tag {{event.worker.first_name }} {{event.worker.last_name}} {{ event.label }} "{{ event.zone_id }}" at {{ event.clock}}
		</div>

		<div slot="modal-footer">
			<button type="button" class="btn btn-secondary" @click="show=false">Close</button>
		</div>

	</b-modal>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'AlertControl',
		data() {
			return {
				show: false,
				log_index: 0
			}
		},
		computed: {
			...mapState([
				'workers',
				'watcher',
				'time',
				'day',
				'flash',
			]),
			worker_types() { return this.$config.worker_types },
			alert: {
				get() { return this.$store.state.alert },
				set(value) {
					this.$store.commit('add_alert', value)
				}
			},
			zones() { return this.$store.state.zones},
		},
		watch: {
			workers: {
				handler() {
					this.setAlerts();
				},
				deep: true
			},
			day() {
				this.log_index = 0;
			}
		},
		mounted() {
			this.setAlerts();
		},
		methods: {
			setAlerts() {

				for (let i in this.watcher[this.day]) {
					if (this.workers[i] == undefined) continue;
					let rec = this.watcher[this.day][i];
					let log = rec;//.slice(this.log_index);
					//log = this.$finder.all({alert: '1'}, log);
					for (let j in log) {
						let event = log[j];
						let alert = {};
						let zone = this.$finder.get('id='+event.zone_id, this.zones);
						let key = i+'-'+j+'-'+zone.id;
						if (event.alert == 1 && this.alert[key] == undefined) {
							alert = $.extend(true, {}, event);
							alert.zone_id = zone.id;
							alert.worker_id = this.workers[i].id;
							alert.worker = {id: this.workers[i].id, first_name: this.workers[i].first_name, last_name: this.workers[i].last_name, badge_number: this.workers[i].badge_number};
							alert.status = 'pending';
							alert.id = key;
							alert.resolution = {};
							alert.result = {};
							alert.exit = {};
							this.$store.commit('add_alert', alert);
							this.workers[i].alert = true;
							this.$set(this.workers, i, this.workers[i]);

							//this.$set(this.alert, key, alert);
							//this.show = true;
						}
						else if (event.type == 'exit') { // automatically clear restricted zone entry events

							let alerts = this.$finder.all({type: 'entry', zone_id: zone.id, worker_id: this.workers[i].id}, this.alert);
							for (let k in alerts) {
								if (alerts[k].day <= event.day && alerts[k].time <= event.time && !alerts[k].exit.key) this.$store.commit('exit_alert', {key: k, day: this.day, time: this.time, type: 'exit', label: "Asset left zone at "+this.$datetime.time(this.time) + "."});
								this.workers[i].alert = false;
								this.$set(this.workers, i, this.workers[i])
							}
						}
						this.log_index++;
					}
				}
				if (Object.keys(this.alert).length == 0) this.show = false;
			}
		}
	}
</script>
